/**
 * @param name {String}
 * @param kind {String}
 * @param messageKind {String}
 * @param body {String}
 * @param customFormId {Number}
 */
import { socketEmit } from 'lib/clients/socket';

export const sendAIRequest = async ({ params, kind = 'myscribe-ai' }) => {
  socketEmit('user-message', {
    kind,
    ...params
  });
};
